import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import './ScheduleReportsCalendar.scss';
import classNames from 'classnames';
import Select from 'react-select';
import {Input} from "reactstrap";
import Modal from "../../../shared/ui/Modal";
import oitsActionCreators from "../../store/oits/action-creators";
import trainingPhasesReportsActionCreators from "../../store/training-phases/action-creators/training-phase-reports";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators";
import testTemplateActionCreators from "../../store/test-templates/action-creators";
import testActionCreators from "../../store/tests/action-creators";
import usersActionCreators from "../../store/users/action-creators";
import departmentSettingsSelectors from "../../store/department-settings/selectors";

const weekdays = moment.weekdays();
const currentMonth = moment().month();
let keyEventListener = null

class ScheduleReportsCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDates: {},
      selectedMonth: moment().month(),
      year: moment().year(),
      selectedReportType: 'dor',
      selectedOitGuid: '',
      selectedGraderGuid: null,
      selectedTestTemplateId: '',
      hour: null,
      minutes: null,
      currentDate: moment(),
      selectedDatesOfWeek: {},
      currentOpenedDatePopup: null,
      isLoading: false,
      showTestTemplateModal: false,
    };
  }

  get canSelectNextMonth() {
    return this.selectedMonth === currentMonth;
  }

  get selectedMonth() {
    return this.state.currentDate.month();
  }

  get datesInMonthValues() {
    const firstDateOfMonth = moment([this.state.year, this.selectedMonth, 1]);
    // Padding days before the day of the first date in the month; account for locales starting week
    //   on Monday instead of Sunday
    const dayOfFirstDayInMonth = firstDateOfMonth.day();
    const paddingDays = (dayOfFirstDayInMonth < 0) ? (7 + dayOfFirstDayInMonth) : dayOfFirstDayInMonth;
    return Array.from({length: (firstDateOfMonth.daysInMonth() + paddingDays)}, (value, index) => {
      const date = ((index + 1) - paddingDays);
      return (index < paddingDays) ? null : date;
    });

  }

  get monthName() {
    return moment([this.state.year, this.selectedMonth, 1]).format('MMMM');
  }

  get scheduledReportsMap() {
    return this.props.reports
      ? this.props.reports.filter(r => {
        return r.getHasScheduledAction()
      }).reduce((acc, r) => {
        let date = `${moment(r.schedule.observationDate).format('YYYY-MM-DD')}`;
        return {
          ...acc,
          [date]: [...(acc[date] || []), {type: r.type, guid: r.guid, isCompleted: r.status !== 'scheduled'}]
        }
      }, {}) : {}
  }

  get testsMap() {
    return this.props.tests
      ? this.props.tests.reduce((acc, t) => {
        let date = `${moment(t.schedule).format('YYYY-MM-DD')}`;
        return {
          ...acc,
          [date]: [...(acc[date] || []), t]
        }
      }, {})
      : {}
  }

  get allowForTypes() {
    if (this.selectedOit) {
      let signFlow = this.selectedOit.trainingTracker.trainingProgram.signFlow
      let types = Object.keys(signFlow)
        .filter(key => {
          return signFlow[key].submit
            && !['cont', 'rrt', 'term', 'tpo'].includes(key)
            && (
              signFlow[key].submit.roles.includes('fto')
              || signFlow[key].submit.roles.includes('ftoc')
              || signFlow[key].submit.roles.includes('sup')
            )

        });
      return types;
    } else {
      return []
    }
  }

  get selectedOit() {
    return this.props.oits
      && this.props.oits.find(o => o.guid === this.state.selectedOitGuid);
  }

  get oitsInProgress() {
    return this.props.oits
      && this.props.oits.filter(o =>
        o.trainingPhases.find(tp => tp.status === 'opened'))
  }

  get canSelectPrevMonth() {
    return !this.canSelectNextMonth;
  }

  get hoursInDay() {
    return new Array(24).fill().map((d, i) => i);
  }

  get daysOfWeek() {
    let startOfWeek = this.state.currentDate.clone().startOf('isoWeek');
    let endOfWeek = this.state.currentDate.clone().endOf('isoWeek');

    let days = [];
    let day = startOfWeek;

    while (day <= endOfWeek) {
      days.push(day);
      day = day.clone().add(1, 'd');
    }

    return days;
  }

  componentWillMount() {
    this.props.fetchTestTemplates()
    this.props.fetchUsersByMaster()
  }

  selectDate(date) {
    if (!this.hasScheduledReport(date) && !this.hasCreatedReport(date) && !!date && this.isDateAvailable(date)) {
      this.setState({
        selectedDates: {
          ...this.state.selectedDates,
          [date]: !this.state.selectedDates[date]
        }
      })
    }
  }

  selectDateOfWeek(date, hour) {

    this.setState({
      selectedDatesOfWeek: {
        ...this.state.selectedDatesOfWeek,
        [this.getIsoDate(date, hour)]: !this.isDateSelected(date, hour)
      }
    })
  }

  isDateSelected(date, hour) {
    return this.state.selectedDatesOfWeek[this.getIsoDate(date, hour)]
  }

  setReportType(type) {
    this.setState({
      selectedReportType: type
    })
  }

  setTestTemplate(testTemplateId) {
    this.setState({
      selectedTestTemplateId: testTemplateId
    });

  }

  onTimeSelectorChanged(date) {
    let d = moment(date);

    this.setState({
      hour: d.hours(),
      minutes: d.minutes()
    });

  }

  componentDidMount() {
    this.props.loadOitsContainer();
    keyEventListener = this.keyEventListener.bind(this)
    document.addEventListener('keyup', keyEventListener, false)
  }

  keyEventListener(e) {
    if (e.which === 39) {
      this.setState({
        currentDate: this.state.currentDate.clone().add(1, 'days')
      })
    } else if (e.which === 40) {
      this.setState({
        currentDate: this.state.currentDate.clone().add(1, 'weeks')
      })
    } else if (e.which === 38) {
      if (
        this.state.currentDate.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
        || this.state.currentDate.valueOf() < moment().valueOf()) {
        return false;
      }
      this.setState({
        currentDate: this.state.currentDate.clone().subtract(1, 'weeks')
      })
    } else if (e.which === 37) {
      if (this.state.currentDate.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
        return false;
      }
      this.setState({
        currentDate: this.state.currentDate.clone().subtract(1, 'days')
      })
    } else if (e.which === 84) {
      this.createTest()
    }


  }

  hasCreatedReport(day) {
    return this.props.reports
      && this.props.reports.find(r => {
        if (r.getHasScheduledAction() && r.status !== 'scheduled') {
          let observationDate = moment(r.schedule.observationDate);
          return observationDate.date() === day && observationDate.month() === this.state.selectedMonth;
        } else {
          return false;
        }
      })
  }

  createTest(d, testTemplateId) {
    if (!this.selectedOit || !testTemplateId) {
      return;
    }
    let date = d || this.state.currentDate.clone();
    this.setState({
      isLoading: true
    });
    this.props.createTest({
      userGuid: this.selectedOit.guid,
      graderGuid: this.state.selectedGraderGuid,
      templateId: testTemplateId,
      schedule: date.format('YYYY-MM-DD')
    }).then(() => this.props.fetchTestsForUser(this.state.selectedOitGuid))
      .then(() => {
      this.setState({
        isLoading: false
      });
    }).catch(() => {
      this.setState({
        isLoading: false
      });
    })

  }

  getIsoDate(day) {
    if (!day) {
      return 'no-date'
    }
    let date = this.state.currentDate.clone();
    date.date(day);
    return date.format('YYYY-MM-DD');
  }

  selectNextMonth() {
    this.setState({
      currentDate: this.state.currentDate.clone().add(1, 'months'),
      year: this.state.currentDate.clone().add(1, 'months').year()
    })
  }

  selectPrevMonth() {
    this.setState({
      currentDate: this.state.currentDate.clone().subtract(1, 'months'),
      year: this.state.currentDate.clone().subtract(1, 'months').year()
    })
  }

  goNextWeek() {
    this.setState({
      currentDate: this.state.currentDate.clone().add(7, 'd')
    })
  }

  goPrevWeek() {
    this.setState({
      currentDate: this.state.currentDate.clone().subtract(7, 'd')
    })
  }

  setSelectedOit(oitGuid, event) {
    let selectedTestTemplateId = this.props.testTemplates.length ? this.props.testTemplates[0].id : ''

    this.setState({
      selectedOitGuid: oitGuid,
      selectedTestTemplateId: selectedTestTemplateId
    });

    if (selectedTestTemplateId) {
      this.props.fetchTestsForUser(oitGuid);
    }
    event.target.blur();
  }

  hasScheduledReport(day) {
    return this.props.reports
      && this.props.reports.find(r => {
        if (r.getHasScheduledAction() && r.status === 'scheduled') {
          let observationDate = moment(r.schedule.observationDate);
          return observationDate.date() === day && observationDate.month() === this.selectedMonth;

        } else {
          return false;
        }
      })
  }

  scheduleTestFromPopup(e, testTemplateId) {
    e.stopPropagation();

    this.createTest(this.state.currentOpenedDatePopup, testTemplateId);

    this.setState({
      currentOpenedDatePopup: null,
      showTestTemplateModal: false
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', keyEventListener, false)
  }

  isDateAvailable(day) {
    if (currentMonth !== this.selectedMonth) {
      return true;
    } else {
      return moment().date() <= day;
    }
  }

  isSelected(day) {
    return this.state.currentDate.date() === day;
  }

  isDatePopupOpened(day) {
    return this.state.currentOpenedDatePopup
      && this.state.currentOpenedDatePopup.date() === day
      && this.state.currentOpenedDatePopup.month() === this.state.currentDate.month()
  }

  openDatePopup(day) {
    let date = this.state.currentDate.clone();
    date.date(day);

    this.setState({
      currentOpenedDatePopup: date,
      selectedGraderGuid: null,
      showTestTemplateModal: true
    });
  }

  closeTestTemplateOptions(e) {
    this.setState({
      showTestTemplateModal: false
    });
  }

  deleteAssiignedTest(e, testId) {
    e.stopPropagation();

    this.props.deleteTest(testId);
  }

  closeDatePopup(e) {
    e.stopPropagation();
    this.setState({
      currentOpenedDatePopup: null
    })
  }

  get filteredTestTemplates() {
    return this.props.testTemplates.filter(tt => tt.status !== 'archived')
  }

  get eligibleGraders() {
    const gradingRoles = ['admin', 'cstaff', 'chief', 'sup', 'ftoc', 'fto', 'depadmin'];
    return this.props.users
      .filter(user => user.active && user.email && gradingRoles.includes(user.roleScope))
      .map(user => ({value: user.guid, label: user.getFullName()}));
  }


  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">ASSIGN TESTS</h4>
        </div>
        <div className="app-content schedule-reports-calendar">
          <div className="schedule-form form column">
            <div className="form-group">
              <Input
                name="type"
                onChange={event =>
                  this.setSelectedOit(event.target.value, event)
                }
                type="select"
                value={this.state.selectedOitGuid}
              >
                <option defaultValue>Select {this.props.oitShortLabel}</option>
                {this.oitsInProgress && this.oitsInProgress.map(oit => (
                  <option key={oit.guid} value={oit.guid}>{oit.getFullName()}</option>
                ))}
              </Input>
            </div>
          </div>
          <div className="instructions">
            Navigate in the calendar using arrows <br/>
            press <b>T </b> to create test from selected template
            <b>or </b>
            <br/>
            <b>click</b> on the date to schedule test
          </div>
          {this.state.selectedOitGuid && (
            <div className="calendar">
              <div className="month">
                <div
                  onClick={() => this.selectPrevMonth()}
                  className={classNames('next-prev', {disabled: !this.canSelectPrevMonth})}>
                  <i className="fa fa-chevron-left"/>
                </div>
                <div>{this.monthName} {this.state.year}</div>
                <div
                  onClick={() => this.selectNextMonth()}
                  className={classNames('next-prev', {disabled: !this.canSelectNextMonth})}>
                  <i className="fa fa-chevron-right"/>
                </div>
              </div>
              <div className="weekdays">
                {weekdays.map(day => (
                  <div className="weekday" key={day}>{day}</div>
                ))}
              </div>
              <div className="days">
                {this.datesInMonthValues.map((day, index) => (
                  <div key={index} className={classNames('day', {
                    'has-day': !!day && this.isDateAvailable(day),
                    'selected': this.state.selectedDates[day],
                    // 'has-report': this.hasScheduledReport(day) || this.hasCreatedReport(day),
                    'is-selected': this.isSelected(day)
                  })}
                       onClick={() => this.openDatePopup(day)}>
                    <div className="day-container">
                      <span className="day-label">{day}</span>
                      {this.testsMap[this.getIsoDate(day)]
                      && this.testsMap[this.getIsoDate(day)].map(t =>
                        <span key={t.id}
                              className="scheduled">
                          <span style={{textTransform: 'uppercase'}}>{t.title} </span>
                          {t.status === 'pending'
                            ? <div className="pending">
                                <span>{t.test_template.title}</span>
                                <i className="fa fa-trash" onClick={(e) => this.deleteAssiignedTest(e, t.id)}></i>
                              </div>
                            : (t.passed ? <span className="passed">{t.test_template.title}</span> : <span className="faiiled">{t.test_template.title}</span>)}
                          </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <Modal
            title="Choose Test Template"
            isOpen={this.state.showTestTemplateModal}
            onClose={(e) => this.closeTestTemplateOptions(e)}
            size="sm"
          >
            <div className="form-group test-template-grader">
              <label htmlFor="test-grader">Choose grader (optional)</label>
              <Select
                inputId="test-grader"
                name="graderGuid"
                placeholder="Search graders or leave unassigned"
                value={this.eligibleGraders.find(grader => grader.value === this.state.selectedGraderGuid) || null}
                options={this.eligibleGraders}
                isClearable={true}
                isSearchable={true}
                onChange={grader => this.setState({selectedGraderGuid: grader ? grader.value : null})}
              />
            </div>
            <div className="test-templates-options">
              {this.filteredTestTemplates.sort().map(tt => (
                <div key={tt.id} onClick={(e) => this.scheduleTestFromPopup(e, tt.id)}>
                  {tt.title}
                </div>
              ))}
            </div>
          </Modal>
        </div>


      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    reports: state.trainingPhases.reports,
    testTemplates: state.testTemplates.list,
    tests: state.tests.list,
    users: state.users.usersByMaster,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadOitsContainer: (scope) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope));
    },
    fetchReports: (trainingPhaseGuid) => {
      return dispatch(trainingPhasesReportsActionCreators.fetchReportsForTrainingPhase(trainingPhaseGuid))
    },
    createScheduledReports: (formData) => {
      return dispatch(trainingPhasesActionCreators.createScheduledReports(formData));
    },
    deleteScheduledReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.deleteScheduledReport(reportGuid));
    },
    fetchTestTemplates() {
      return dispatch(testTemplateActionCreators.fetchTestTemplates());
    },
    fetchUsersByMaster() {
      return dispatch(usersActionCreators.fetchUsersByMaster());
    },
    createTest(form) {
      return dispatch(testActionCreators.createTest(form));
    },
    deleteTest(testId) {
      return dispatch(testActionCreators.deleteTest(testId));
    },
    fetchTestsForUser(guid) {
      return dispatch(testActionCreators.fetchTestsForUser(guid));
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleReportsCalendar);
